import serverURL from "../../config/serverConfig"
import { useEffect, useState, useContext } from "react"
import { userContext } from '../../contexts/userContext';
import { useUserClients } from "../../hooks/db";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft, CheckCircle } from "lucide-react";

// import { getProjectList } from "../scripts/getProjects"
import NewProjectForm from "./NewProjectForm"

const CreateProject = () => {

    const user = "jaykurzweil"
    const user_id = useContext(userContext);
    const navigate = useNavigate();
    const userClients = useUserClients(user_id[0]); 

    let projectList = []
    const [isUploaded, setUploaded] = useState(false);
    const [projectID, setProjectID] = useState();
    const [createdTitle, setCreatedTitle] = useState("");


    //load project list
    // useEffect( () => {
    //     console.log(serverURL + "data/" + user + "/projects/projectList.json")
    //     fetch(serverURL + "data/" + user + "/projects/projectList.json")
    //         .then(response => response.json())
    //         .then((jsonData) => {
    //             projectList = jsonData
    //             console.log(projectList.length)
    //         })
    //         .catch((error) => {
    //             //console.log(error)
    //             console.log("No Project List Found")
    //         })
    // },[])

    //add new project to list - callback
    const addNew = (details) => {
        const clientDetails = details.client.split("^");
        setCreatedTitle(details.title);
        console.log("client deatails: ", clientDetails)

        fetch(serverURL+"createProject", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                },
            body: JSON.stringify({
                user_id: user_id[0],
                client: clientDetails[0],
                //client_id: details.client_id,
                title: details.title,
                // type: details.type,
                // num_of_songs: details.songs,
                description: details.description,
                start_date: details.startDate,
                due_date: details.dueDate,
                status: details.status,
                fee: details.fee,
                paid: details.paid,
                client_id: clientDetails[1] ?? details.client_id,
                //notes: details.notes,

            }),
        })
        .then((response) => response.json())
        .then((data) => {
            let id = data[0].project_id
            id = Number(id);
            console.log(data[0].project_id);
            console.log(id)
            setUploaded(true)
            setProjectID(id)
        })
        .catch((error) => {
            console.log("Error creating project: " + error)
        });
    }

    useEffect( () => {
        //console.log(serverURL + "data/" + user + "/projects/projectList.json")
        fetch(serverURL+"createNote", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                },
            body: JSON.stringify({
                project_id: projectID
                //notes: details.notes,

            }),
        })
        .then((response) => response.json())
        .then((data) => {
            //console.log(data);
            setUploaded(true)
            //setProjectID(data.project_id)
        })
        .catch((error) => {
            console.log(error)
        });

        fetch(serverURL+"createToDoList", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                },
            body: JSON.stringify({
                project_id: projectID
                //notes: details.notes,

            }),
        })
        .then((response) => response.json())
        .then((data) => {
            //console.log(data);
            //setUploaded(true)
            //setProjectID(data.project_id)
        })
        .catch((error) => {
            console.log(error)
        });
    },[projectID])


    return (
        <div className="m-auto mt-6 px-10 max-w-[600px]">
            <button
                onClick={() => navigate(-1)}
                className="flex items-center gap-1.5 text-[#666] hover:text-[#ffee00] text-xs uppercase tracking-wider font-medium mb-4 transition-colors duration-200 w-fit"
            >
                <ArrowLeft size={14}/> Back
            </button>

            {isUploaded && projectID && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm">
                    <div className="gradientBG flex flex-col items-center gap-4 px-10 py-8 max-w-[360px] w-full text-center">
                        <CheckCircle size={36} className="text-[#46C408]" />
                        <h3 className="text-base font-semibold uppercase tracking-wider">Project Created</h3>
                        <p className="text-sm text-[#888]">"{createdTitle}" has been added.</p>
                        <div className="flex flex-col gap-2 w-full mt-2">
                            <Link
                                to="/project"
                                state={{ project_id: projectID }}
                                className="w-full py-2 px-4 bg-[#ffee00] text-black font-bold text-xs uppercase tracking-widest rounded-lg text-center transition-all duration-200 hover:bg-[#ffe000] hover:shadow-[0_4px_20px_rgba(255,238,0,0.25)]"
                            >
                                Open Project
                            </Link>
                            <button
                                onClick={() => { setUploaded(false); setProjectID(undefined); }}
                                className="w-full py-2 px-4 text-[#666] hover:text-[#aaa] text-xs uppercase tracking-widest transition-colors duration-200"
                            >
                                Create Another
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <NewProjectForm submit={addNew} clients={userClients}/>
        </div>
    )
}

export default CreateProject